import { render } from "./Chaves.vue?vue&type=template&id=550a6ba4&scoped=true"
import script from "./Chaves.vue?vue&type=script&lang=js"
export * from "./Chaves.vue?vue&type=script&lang=js"

import "./Chaves.vue?vue&type=style&index=0&id=550a6ba4&scoped=true&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550a6ba4"]])

export default __exports__